import { defineComponent } from 'vue';
// Import Swiper Vue.js components
import { ref } from 'vue';
import { Thumbs, EffectFade, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';

import "swiper/css/navigation"
import "swiper/css/thumbs"
import 'swiper/css/effect-fade';

// Import Lightbox
import lightbox from '/src/ts/modules/lightbox.ts';

export default defineComponent({
    delimiters: ['${', '}'],
    components: {
        Swiper,
        SwiperSlide,
    },
    props: {
        isSos: {
          type: Boolean,
          default: false,
        },
        thumbnails: {
            type: Array,
            default: () => [],
            required: true
        },
        images: {
            type: Array,
            default: () => [],
            required: true
        },
        isOnSale: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        const thumbsSwiper = ref(null);
        const setThumbsSwiper = (swiper) => {
          thumbsSwiper.value = swiper;
        };
        return {
          Thumbs,
          EffectFade,
          Navigation,
          thumbsSwiper,
          setThumbsSwiper
        };
    },
    data() {
        return {
            lightbox: null,
        };
    },
    computed: {
        isCustomerWithSaleAccess() {
            return this.$store.getters.statuses.isCustomerWithSaleAccess;
        },
        showIsOnSale() {
            return this.isCustomerWithSaleAccess && this.isOnSale;
        },
    },
    mounted() {
        const elements = [];
        for (const img of this.images) {
            elements.push({"href": img})
        }

        this.lightbox = lightbox({
            "elements": elements,
        });
    },
    methods: {
        openLightbox() {
            if (!this.lightbox) return;
            const productSlide = document.querySelector('.js-product-images');
            if (!productSlide) return;
            const activeSlide = productSlide.querySelector('.swiper-slide-active');
            if (!activeSlide) return;
            const img = activeSlide.querySelector('img');
            if (!img) return;
            this.lightbox.openAt(img.dataset.index);
        }
    },
    template: '#t-product-lightbox',
});
